export function TotalKg(
  grammage?: number | string | null,
  quantity?: number | string | null
) {
  if (Number(grammage) && Number(quantity) && grammage && quantity) {
    return +(+grammage * +quantity).toFixed(2);
  }
  return '';
}
